import React from "react";
import { CircleLogo } from "web/react/emo/circle-logo";
import { HStack } from "web/react/emo/h-stack";
import { Heading } from "web/react/emo/heading";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";
import { VerifiedBadge } from "web/react/emo/verified-badge";

interface SellerLogoCardProps {
    imageURL: string;
    sellerName: string;
    size: "sm" | "md";
    isCheckout?: boolean;
    children?: React.ReactNode;
}

export function SellerLogoCard({
    imageURL,
    sellerName,
    size,
    isCheckout = false,
    children,
}: SellerLogoCardProps): React.ReactElement {
    const title =
        size === "sm" ? (
            <Text textStyle="body">{sellerName}</Text>
        ) : (
            <Heading textStyle="hero-xs">{sellerName}</Heading>
        );

    return (
        <HStack spacing="sm" align="center">
            <CircleLogo size={size} imageURL={imageURL} name={sellerName} />
            <VStack spacing="xxxs">
                <HStack spacing="xxs" align="center">
                    {title}
                    {isCheckout && <VerifiedBadge size="sm" />}
                </HStack>
                {children}
            </VStack>
        </HStack>
    );
}
